import {AfterViewInit, Component, OnInit, ViewChildren} from '@angular/core';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
    selector: 'app-project-is-locked-modal',
    templateUrl: './project-is-locked-modal.component.html',
    styleUrls: ['./project-is-locked-modal.component.scss']
})
export class ProjectIsLockedModalComponent extends ModalDialogV3 implements OnInit, AfterViewInit {

    @ViewChildren('focusedButton') fb;
    public errMessage: string;
    public message: string

    constructor() {
        super();
    }


    ngOnInit(): void {
        this.message = this.modalParams.model['message'];
        if (!  this.message ) {
            this.errMessage = this.modalParams.model['errMessage'];
        }
        // console.log('modalParams:',this.modalParams);
    }

    onCancelBtnClicked() {
        super.close();
    }

    onConfirmBtnClicked() {
        this.announceModelChanged({dialogConfirmed: true});
        super.close();
    }

    ngAfterViewInit(): void {
        this.fb.first.nativeElement.focus();
    }
}
